"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _index = require("../../utils/styles/index");
/* ++++++++++ --------------- IMPORTS --------------- ++++++++++ */

/* ++++++++++ --------------- EXPORT : SEARCH : STYLES --------------- ++++++++++ */


var _default = {
  search: {
    height: (0, _index.pxToEm)(48),
    margin: '0',
    display: 'flex',
    alignItems: 'center',
    alignContent: 'flex-start',
    position: 'relative',
    zIndex: '2',
    transition: _index.theme.animation.general('all'),
    background: _index.theme.color.supporting.light.swatch,
    border: (0, _index.replacePXinStringWithEM)("1px solid transparent"),
    borderStyle: 'solid none',
    '& .search-icon': {
      width: (0, _index.pxToEm)(30),
      height: (0, _index.pxToEm)(50),
      color: _index.theme.color.neutral.dark.swatch,
      display: 'flex',
      alignContent: 'center',
      alignItems: 'center',
      justifyContent: 'flex-start'
    },
    '& .element': {
      color: _index.theme.color.neutral.dark.swatch,
      flex: '1',
      '& input': {
        backgroundColor: 'transparent',
        border: '0',
        color: 'inherit',
        fontSize: (0, _index.pxToEm)(16),
        width: '100%',
        height: (0, _index.pxToEm)(50),
        margin: '0',
        padding: '0',
        outline: 'none',
        '&::placeholder': {
          color: _index.theme.color.supporting.dark.swatch,
          opacity: '.4'
        }
      }
    },
    '& .left-parent': {
      display: 'flex',
      '& .left-child': {
        height: '100%',
        marginRight: "".concat((0, _index.pxToEm)(20))
      }
    },
    '& .right-parent': {
      display: 'flex',
      '& .right-child': {
        height: '100%',
        marginLeft: "".concat((0, _index.pxToEm)(20))
      }
    },
    //SEARCH-CHILDREN-SPECFIC-STYLES
    //DROPDOWN
    '& .searchabledropdown': {
      minWidth: "".concat((0, _index.pxToEm)(110)),
      maxWidth: "".concat((0, _index.pxToEm)(130)),
      height: (0, _index.pxToEm)(48),
      '& .title': {
        color: _index.theme.color.primary.medium.swatch,
        fontSize: (0, _index.pxToEm)(14)
      },
      '& .name-sort-down': {
        padding: (0, _index.pxToEm)(10),
        marginBottom: (0, _index.pxToEm)(3)
      },
      '& .name-menuItems': {
        '&.active-true': {
          position: 'absolute',
          width: "".concat((0, _index.pxToEm)(150))
        }
      }
    },
    '&:hover': {
      filter: 'brightness(97%)'
    }
  }
};
exports.default = _default;